import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";

import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import get from "lib/requests";

import Datetime from "react-datetime";
import moment from "moment";
import { useSelector } from "react-redux";

import { ErrorMessage } from "components/Common/toastify";

import Loading from "components/Common/loading";

const useStyles3 = makeStyles(javascriptStyles);
const useStyles2 = makeStyles(headersStyle);

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const SubscriptionReportDialog = ({
	subscriptionReportDialog,
	setSubscriptionReportDialog,
}) => {
	const classes2 = useStyles2();
	const classes3 = useStyles3();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const userInfo = useSelector((state) => state.user);
	const [startDate, setStartDate] = useState(moment().subtract(1, "day")); // Today
	const [endDate, setEndDate] = useState(moment()); // +1 month

	useEffect(() => {}, [userInfo]);
	const today = moment();
	const maxEndDate = moment().add(1, "month");

	const validDate = (current) => {
		return current.isSameOrBefore(today, "day");
	};
	const getLicenseUseReport = async () => {
		setLoading(true);
		try {
			const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
			const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
			await get(
				`/api/license-use-report?startdate=${formattedStartDate}&enddate=${formattedEndDate}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Use", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Use", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("License Use", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const getLicenseUseDailyReport = async () => {
		setLoading(true);
		try {
			const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
			const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
			await get(
				`/api/license-use-daily-report?startdate=${formattedStartDate}&enddate=${formattedEndDate}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Use", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Use", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("License Use", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const getLicenseExportAsperTenant = async () => {
		setLoading(true);
		const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
		const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
		try {
			await get(
				`/api/license-export-asper-tenant?startdate=${formattedStartDate}&enddate=${formattedEndDate}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Assignment Per User Per Tenant", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Assignment Per User Per Tenant", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage(
				"License Assignment Per User Per Tenant",
				"Something went wrong try again!!"
			);
			setLoading(false);
		}
	};

	const downloadCurrentSubscriptionList = async () => {
		setLoading(true);
		try {
			await get(`/api/download-annuity-report`, true)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Assignment Per User Per Tenant", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Assignment Per User Per Tenant", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage(
				"License Assignment Per User Per Tenant",
				"Something went wrong try again!!"
			);
			setLoading(false);
		}
	};

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal + " " + classes3.createCustomerModal,
			}}
			open={subscriptionReportDialog}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setSubscriptionReportDialog(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(
					classes3.container,
					classes3.modalHeader,
					classes3.dialogTitle
				)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setSubscriptionReportDialog(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>
					Subscription Change Report{" "}
					<button
						disabled={loading}
						className={classNames(
							classesCSStyles?.buttonPrimary,
							classesCSStyles?.mx5
						)}
						onClick={() => downloadCurrentSubscriptionList()}>
						Download Current Subscription List
					</button>
				</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				{/* <hr /> */}
				{loading && <Loading width={30} height={30} className={classes2.loading} />}
				<div className={classNames(classesCSStyles.mx5, classesCSStyles?.my10)}>
					{/* <GridContainer className={classNames(classesCSStyles.marginAuto)}>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(classesCSStyles?.leftAlign)}>
							<button
								disabled={loading}
								className={classNames(
									classesCSStyles?.buttonPrimary,
									classesCSStyles?.mx5
								)}
								onClick={() => downloadCurrentSubscriptionList()}>
								Download Current Subscription List
							</button>
						</GridItem>
					</GridContainer> */}
					<GridContainer className={classNames(classesCSStyles.marginAuto)}>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(loading ? classesCSStyles.loading : "")}>
							{loading && (
								<Loading
									width={30}
									height={30}
									className={classesCSStyles.absoluteLoading}
								/>
							)}
							<GridContainer className={classNames(classesCSStyles.marginAuto)}>
								{/* <GridItem xs={12} sm={12} md={12}>
									<hr />
								</GridItem> */}
								<GridItem xs={12} sm={6} md={6}>
									<div className={classesCSStyles?.reportTitle}>License Use</div>
									<div className={classNames(classesCSStyles?.my10)}>
										<Datetime
											inputProps={{ placeholder: "From date" }}
											dateFormat="MM/DD/YYYY"
											timeFormat={false}
											value={startDate}
											onChange={(event) => {
												setStartDate(event);
											}}
											isValidDate={validDate}
										/>
									</div>

									<div className={classNames(classesCSStyles?.my10)}>
										<Datetime
											inputProps={{ placeholder: "To date" }}
											dateFormat="MM/DD/YYYY"
											timeFormat={false}
											value={endDate}
											onChange={(event) => {
												setEndDate(event);
											}}
											isValidDate={validDate}
										/>
									</div>

									<div
										className={classNames(
											classesCSStyles?.my10,
											classesCSStyles?.rightAlign
										)}>
										<button
											disabled={loading}
											className={classNames(classesCSStyles?.buttonPrimary)}
											onClick={() => getLicenseUseReport()}>
											Export
										</button>

										<button
											disabled={loading}
											className={classNames(classesCSStyles?.buttonPrimary)}
											onClick={() => getLicenseUseDailyReport()}>
											Export Daily Report
										</button>
									</div>
								</GridItem>
								{userInfo?.account_no == "70999" && (
									<GridItem xs={12} sm={6} md={6}>
										<div className={classesCSStyles?.reportTitle}>
											License Assignment Per User Per Tenant
										</div>
										<div className={classNames(classesCSStyles?.my10)}>
											<Datetime
												inputProps={{ placeholder: "From date" }}
												dateFormat="MM/DD/YYYY"
												timeFormat={false}
												value={startDate}
												onChange={(event) => {
													setStartDate(event);
												}}
												isValidDate={validDate}
											/>
										</div>

										<div className={classNames(classesCSStyles?.my10)}>
											<Datetime
												inputProps={{ placeholder: "To date" }}
												dateFormat="MM/DD/YYYY"
												timeFormat={false}
												value={endDate}
												onChange={(event) => {
													setEndDate(event);
												}}
												isValidDate={validDate}
											/>
										</div>

										<div
											className={classNames(
												classesCSStyles?.my10,
												classesCSStyles?.rightAlign
											)}>
											<button
												disabled={loading}
												className={classNames(classesCSStyles?.buttonPrimary)}
												onClick={() => getLicenseExportAsperTenant()}>
												Export
											</button>
											{/* <Button
												color="info"
												size="sm"
												type="button"
												onClick={getLicenseExportAsperTenant}>
												Export
											</Button> */}
										</div>
									</GridItem>
								)}
							</GridContainer>
						</GridItem>
					</GridContainer>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default SubscriptionReportDialog;
